<template>
<div>
  <h1 class="com-title com-ht"><i></i>消息通知设置</h1>
  <div class="box-card">
    <p>
      短信通知：<el-switch v-model="settingsConfig.smsFlag" :active-color="activeColor" :active-value="activeVal" :inactive-value="inactiveVal" @change="settingsChange($event,'smsFlag')"></el-switch>
    </p>
    <span>提示：开启时，签约、审批等信息将通过短信通知您（若企业人脸识别授权列表中仅有法人，则将发送给法人，若人脸识别授权列表存在授权人，则将发送给默认授权人）。</span>
  </div>
  <div class="box-card">
    <p>
      邮件通知：
      <el-switch
        :value="settingsConfig.emailFlag"
        :active-color="activeColor"
        :active-value="activeVal"
        :inactive-value="inactiveVal"
        @change="bindEmailSwitchChange($event,'emailFlag')"
      ></el-switch>
      <template v-if="settingsConfig.email">
          <span class="bind-target">已绑定：{{settingsConfig.email}}</span>
<!--          <span class="unbind" @click="unnindEmail">解绑</span>-->
          <span class="unbind" @click="emailEditFn">修改</span>
        </template>
    </p>
    <span>提示：开启时，签约、审批等信息将通过邮件通知您（邮件将发送至企业账号对应的邮箱）。</span>
  </div>
  <div class="box-card">
    <p>
      微信通知：
      <el-switch
        :value="settingsConfig.wxFlag"
        :active-color="activeColor"
        :active-value="activeVal"
        :inactive-value="inactiveVal"
        @change="weChatSwitchChange($event,'wxFlag')"></el-switch>
        <span v-show="settingsConfig.wxName">
          <span class="bind-target">已绑定：{{settingsConfig.wxName}}</span>
          <span slot="reference" class="unbind" @click="unnindWx">解绑</span>
        </span>
    </p>
    <span>提示：开启时，签约、审批等信息将通过微信消息通知您（签署通知将发送至当前账号绑定的微信账号，一个账号仅能绑定一个微信）。</span>
  </div>
  <!-- 弹窗组件 -->
  <!-- 绑定微信通知弹窗 -->
  <el-dialog
    title="绑定微信"
    :visible.sync="bindWeChatVisi"
    width="50%"
    >
    <div class="qrcode-box">
      <qrcode :value="bindWechatQR.url" :size="260" leave="H" key="evidence" />
      <p>使用手机微信扫码绑定</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="bindWeChatVisi = false">关 闭</el-button>
    </span>
  </el-dialog>
  <!-- 绑定邮箱 -->
  <el-dialog
    title="绑定邮箱"
    :visible.sync="bindEmailVisi"
    width="50%"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    >
    <el-form ref="bingEmailRef" :model="bingEmailForm" :rules="bindEmailRules" label-width="80px">
      <el-form-item label="邮箱：" prop="email">
        <el-input v-model="bingEmailForm.email"></el-input>
      </el-form-item>
      <el-form-item label="验证码：" prop="valicode">
        <el-input v-model="bingEmailForm.valicode">
          <el-button
            slot="append"
            type="primary"
            :disabled="emailCodeCountdown > 0"
            @click="sendVaild"
          >{{emailCodeCountdown > 0 ?`${emailCodeCountdown}S` : '发送验证码'}}</el-button>
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="bindnotifyEmail">绑 定</el-button>
    </span>
  </el-dialog>
  <!-- 验证码实例 组件中有多处使用验证码，避免重复创建实例 -->
    <div v-show="false">
      <ali-captcha
        :handCallback="countdownLe"
        :targetId="bingEmailForm.email"
        :verifyType='BUSITYPE.OTHER'
      >
        <button ref="aliCaptchaRef">发送验证码</button>
      </ali-captcha>
    </div>
  <!-- 个人账号修改邮箱 -->
  <el-dialog
    title="提示"
    :visible.sync="PersonchangeEmailVisi"
    :show-close="false"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    width="50%">
    <el-form label-width="120px" size="small" class="user-form-sty" :model="PersonAccount" :rules="accountRules" ref="personChangeEmailRef">
      <el-form-item label="原邮箱：">
        <div class="item-box">
          <el-input :value="settingsConfig.email" disabled></el-input>
        </div>
      </el-form-item>
      <el-form-item label="验证码：" prop="valicode">
        <div class="item-box">
          <el-input v-model="PersonAccount.valicode" :maxLength="4" placeholder="请输入验证码">
            <template slot="append">
              <span class="img-code" @click="getImgCode"><img :src="'data:image/png;base64,'+ imgCodeData.imgPath"/> </span>
            </template>
          </el-input>
        </div>
      </el-form-item>
      <el-form-item label="新邮箱：" prop="email">
        <div class="item-box">
          <el-input v-model="PersonAccount.email" placeholder="请输入新邮箱"></el-input>
        </div>
        <span style="color: #ec1c1c">注：请在新邮箱中点击链接激活邮箱换绑</span>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button @click="PersonchangeEmailVisi = false">取 消</el-button>
        <el-button type="primary" @click="unbindEmailOfPerson">确 定</el-button>
      </span>
  </el-dialog>
</div>
</template>
<script>
// components
import aliCaptcha from "@/components/send-auth-validcode/aliCaptchaNew.vue";
import Qrcode from "qrcode.vue";
// API
import { ApiMethods } from "@/assets/js/http-serve/http-methods.js";
// tool
import { email, password } from "@/assets/js/lib/valid-methods.js";
import { BUSITYPE } from "@/assets/js/utils/others";
import {postImgCode} from "../../../assets/js/http-serve/http-methods";

  export default {
    components:{aliCaptcha,Qrcode},
    data () {
      // 这里存放数据
      return {
        PersonchangeEmailVisi: false,
        PersonAccount:{
          email:'',
          valicode:'',
        },
        imgCodeData: {},
        accountRules:{
          email:[{validator: email, trigger: "change" }],
          password:[{validator: password, trigger: "change" }],
          // confirmPWD:[{validator: this.confirmPWDVer, trigger: "change" }],
          valicode: [{required: true,  message: '请输入验证码', trigger: "change"}]
        },
        BUSITYPE,
        emailCodeCountdown:0,
        bindEmailVisi:false,
        bingEmailForm:{
          email: "",
          valicode: ""
        },
        bindEmailRules:{
          email: [{validator:email,trigger:"blur"}],
          valicode:[{ required: true, message: '请输入验证码', trigger: 'change' }],
        },
        bindWeChatVisi:false,
        inactiveVal:0,
        activeVal:1,
        activeColor:"#ec1c1c",
        settingsConfig:{
          smsFlag:1,
          emailFlag:0,
          wxFlag:0,
        },
        bindWechatQR:''
      }
    },
    // 监听属性 类似于data概念
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
      emailEditFn() {
        this.getImgCode();
        this.PersonchangeEmailVisi = true;
      },
      // 个人账号修改邮箱
      unbindEmailOfPerson(){
        this.$refs.personChangeEmailRef.validate((valid) => {
          if (valid) {
            const loading = this.$loading();
            const param={
              imageCode: this.imgCodeData.imgToken + '_' + this.PersonAccount.valicode,
              email:this.PersonAccount.email
            };
            ApiMethods.accountCenter.changeV2Email(param).then(res=>{
              if(!res.success) return this.$message.error(res.msg || '修改失败')
              this.$message.success(res.msg || `我们已经向您的新邮箱 ${res.data} 发送了一封验证邮件，请及时查收。`);
              this.PersonAccount.email = '';
              this.PersonAccount.valicode = '';
              this.PersonchangeEmailVisi = false;
            }).finally(()=>{
              loading.close()
            })
          }
        })
      },
      getImgCode () {
        postImgCode().then(({ data }) => {
          this.imgCodeData = data;
        });
      },

      // * email 通知事件 start
      /** 邮箱绑定change */
      bindEmailSwitchChange(val){
        if(!this.settingsConfig.email && val){
          this.getImgCode();
          this.bindEmailVisi = true
          // this.PersonchangeEmailVisi = true
        }else{
          // 关闭通知
          this.settingsConfig.emailFlag = Number(val)
          this.saveSettings({key:'emailFlag',val:Number(val)})
        }
      },
      /** 解绑邮箱 */
      unnindEmail(){
        const _this = this,{smsFlag,wxFlag}=this.settingsConfig;
        const allClosed = [smsFlag,wxFlag].every(val=>val === 0)
        if(allClosed){
          _this.$message.warning('至少需保留一种通知方式！')
          return
        }
        _this.$confirm('解除绑定后，将无法在收到通知邮件，是否确认？','解绑邮箱',{
            confirmButtonText: '确 认',
          }).then(()=>{
            // 解除绑定
            this.loadingStart()
            ApiMethods.PreferenceSettingsAPI.unnindEmailNotify().then(res=>{
              if(!res.success) return this.$message.error(res.description);
              // 解绑后关闭通知开关
              _this.settingsConfig.emailFlag = 0
              _this.saveSettings({key:'emailFlag',val:0})
            }).finally(()=>{this.loadingClose()})
          }).catch(()=>{})
      },
      sendVaild(){
        this.$refs.bingEmailRef.validateField('email',(err)=>{
          if(err) return false;
          // 获取到验证码组件ref
          const aliCaptchaRef = this.$refs.aliCaptchaRef
          // 触发验证码组件点击事件
          aliCaptchaRef.click()
        })
      },
      // 验证码倒计时
      countdownLe(){
        let interval=null
        this.emailCodeCountdown = 120
        interval = setInterval(()=>{
          this.emailCodeCountdown--
          if(this.emailCodeCountdown === 0) clearInterval(interval)
        },1000)
      },
      /** 绑定通知邮箱 */
      bindnotifyEmail(){
        this.$refs.bingEmailRef.validate((valid)=>{
          if(!valid) return false;
          this.loadingStart()
          ApiMethods.PreferenceSettingsAPI.notifyEmail(this.bingEmailForm).then(res=>{
            if(!res.success) return this.$message.error(res.description);
            // 绑定成功
              this.settingsConfig.emailFlag = 1
              this.saveSettings({key:'emailFlag',val:1})
              this.bindEmailVisi = false
          }).finally(()=>{this.loadingClose()})
        })
      },
      // * email 通知事件 end
      // * 微信 通知事件 start
      /** 微信通知change */
      weChatSwitchChange(val,key){
        if(val){
          // 绑定微信
          this.genQrcodeWechat()
        }else{
          this.settingsConfig[key] = val
          this.saveSettings({key:'wxFlag',val})
        }
      },
      /** 获取微信绑定url */
      genQrcodeWechat(){
        this.loadingStart()
        const _this = this;
          ApiMethods.PreferenceSettingsAPI.genQrcodeNotify().then(res=>{
            if(!res.success) return _this.$message.error(res.description);
            _this.bindWechatQR = res.data
            _this.bindWeChatVisi = true;
            // 2秒后开始队列查询
            setTimeout(() => {
              _this.bindWechatRes()
            }, 2*2000);
          }).finally(()=>{_this.loadingClose()})
      },
      /** 绑定微信结果查询 */
      bindWechatRes(){
        const _this=this;
        const BINDWECHATTIMER = setTimeout(()=>{
          // 查询微信绑定结果
          ApiMethods.PreferenceSettingsAPI.qrcodeNotifyResp({jzqWxId:this.bindWechatQR.jzqWxId}).then(BINDRES=>{
            if(!BINDRES.success) return _this.$message.error(BINDRES.description);
            if(BINDRES.data.subscribe == 1){
              // 绑定成功
              _this.settingsConfig.wxFlag = 1
              this.saveSettings({key:'wxFlag',val:1})
              clearTimeout(BINDWECHATTIMER)
              this.bindWeChatVisi = false
            }else{
              _this.bindWechatRes()
            }
          })
        }, 2 * 1000)
      },
      /** 解绑微信 */
      unnindWx(){
        const _this = this,{emailFlag,smsFlag}=this.settingsConfig;
        const allClosed = [emailFlag,smsFlag].every(val=> val === 0)
        if(allClosed){
          _this.$message.warning('至少需保留一种通知方式！')
          return
        }
        // 解绑微信
          _this.$confirm('解除绑定后，将无法在收到微信消息通知，是否确认？','解绑微信',{
            confirmButtonText: '确 认',
          }).then(()=>{
            // 解除绑定
            _this.loadingStart()
            ApiMethods.PreferenceSettingsAPI.unnindWxNotify().then(res=>{
              if(!res.success) return this.$message.error(res.description);
              // 解绑后关闭通知开关
              _this.settingsConfig.wxFlag = 0
              _this.saveSettings({key:'wxFlag',val:0})
            }).finally(()=>{_this.loadingClose()})
          }).catch(()=>{})
      },
      // * 微信 通知事件 end
      // 通知方式change
      settingsChange(val,key){
        this.saveSettings({key,val})
      },
      // 保存设置
      saveSettings({key,val}){
        const _this = this,{emailFlag,smsFlag,wxFlag}=this.settingsConfig;
        const allClosed = [emailFlag,smsFlag,wxFlag].every(val=> val === 0)
        if(allClosed){
          _this.$message.warning('至少需保留一种通知方式！')
          if(key) _this.settingsConfig[key] = Number(!val)
          return
        }
        _this.loadingStart()
        ApiMethods.PreferenceSettingsAPI.setNotify(this.settingsConfig).then(res=>{
          if(!res.success) {
            if(key) _this.settingsConfig[key] = Number(!val)
            return _this.$message.error(res.description)
          };
          this.$message.success(val == 1 ? '开启成功' : '关闭成功')
          if(['wxFlag','emailFlag'].includes(key)) {
            _this.getNotifySettings()
          }
        }).finally(()=>{_this.loadingClose()})
      },
      /** 查询偏好设置 */
      getNotifySettings(){
        this.loadingStart()
          ApiMethods.PreferenceSettingsAPI.getNotify().then(res=>{
            if(!res.success) return this.$message.error(res.description);
            if(res.data){
              // 创建一个新对象而不是直接修改
              const newSettings = JSON.parse(JSON.stringify(res.data))
              // 使用 $set 替换整个对象
              this.$set(this, 'settingsConfig', Object.assign({}, this.settingsConfig, newSettings))
              this.settingsConfig.wxName = res.data.wxName ? res.data.wxName : ''
              this.settingsConfig.email = res.data.email ? res.data.email : ''
            }
          }).finally(()=>{this.loadingClose()})
      },
      loadingStart (info = null) {
        this.loadingClose();
        this.loading = this.$loading({
          lock: true,
          text: info || "正在拼命加载中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, .5)"
        });
      },
      loadingClose () {
        if (this.loading) {
          this.loading.close();
        }
      },
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {
      this.getNotifySettings()
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {},
  }
</script>

<style lang='less' scoped>
  // @import url(); 引入公共css类
  @ebq-red:#ec1c1c;
  .box-card{
    width: 98%;
    margin: 2vh auto;
    padding: 1vh;
    border-radius: 6px;
    box-shadow: 0 1px 4px 1px #9f9c9c;
    >p{
      font-size: 0.85vw;
      font-weight: bold;
      display: flex;
      align-items: center;
    }
    .bind-target{
      margin:0 1vw;
    }
    .unbind{
      color:@ebq-red;
      cursor: pointer;
    }
  }
  .qrcode-box{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .img-code {
    background-color: #fff;
    display: inline-block;
    margin: 0 -20px;
    width: 100px;
    line-height: 30px;
    text-align: center;
    cursor: pointer;

    img {
      vertical-align: middle;
      display: inline-block;
      height: 30px;
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// pages/tpl/components/msgNotifi.vue